import "regenerator-runtime/runtime";

import React from "react";

import { FixedSizeList as List } from "react-window";
/* import { VariableSizeList as List } from "react-window"; */
/* import { DynamicSizeList as List } from "react-window"; */

import AutoSizer from "react-virtualized-auto-sizer";
import InfiniteLoader from "react-window-infinite-loader";

const LOADING = 1;
const LOADED = 2;
let itemStatusMap = {};

const isItemLoaded = index => !!itemStatusMap[index];

const list = [];

const hasNextPage = true;

/* const itemCount = hasNextPage ? list.length + 1 : list.length; */
const itemCount = 1000;
console.log("itemCount: ", itemCount);

var rowCount = hasNextPage ? list.length + 1 : list.length;
console.log("rowCount: ", rowCount);

const loadMoreItems = (startIndex, stopIndex) => {
  console.log(`loadMoreItems ${startIndex} ${stopIndex}`);
  for (let index = startIndex; index <= stopIndex; index++) {
    itemStatusMap[index] = LOADING;
  }
  return new Promise(resolve =>
    setTimeout(() => {
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMap[index] = LOADED;
        list[index] = `Row ${index}`;
      }
      resolve();
    }, 2500)
  );
};

/* function isRowLoaded({ index }) {
 *   return !!list[index];
 * } */

var isNextPageLoading = false;

const isRowLoaded = ({ index }) => !hasNextPage || index < list.length;

const loadNextPage = (startIndex, stopIndex) => {
  console.log(`loadNextPage ${startIndex} ${stopIndex}`);

  isNextPageLoading = true;
  console.log("loadNextPage loading...");

  for (let index = startIndex; index <= stopIndex; index++) {
    itemStatusMap[index] = LOADING;
  }

  return fetch(
    `/fashion/load_more?start_index=${startIndex}&stop_index=${stopIndex}`
  ).then(response => {
    // Store response data in list...
    for (let index = startIndex; index <= stopIndex; index++) {
      itemStatusMap[index] = LOADED;
      list[index] = `Row ${index}`;
    }

    isNextPageLoading = false;
    rowCount = rowCount + 1;
    console.log("loadNextPage loaded.");
  });
};

const loadMoreRows = isNextPageLoading ? () => {} : loadNextPage;

async function loadMorePosts() {
  let response = await fetch(`/fashion/load_more`);
  let data = await response.json();
  return data;
}

/* const Row = ({ index, style }) => <div style={style}>Row {index}</div>; */

// TODO use immutable?

const Row = ({ index, style }) => {
  let content;

  if (!isRowLoaded({ index })) {
    content = "Loading...";
  } else {
    content = list[index];
  }

  return <div style={style}>{content}</div>;
};

class FashionList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      count: 0,
      isLoading: false
    };

    this.loadMoreItems2 = this.loadMoreItems2.bind(this);
  }

  componentDidMount() {
    console.log("FashionList componentDidMount");

    /* let data = loadMorePosts();
     * console.log("data: ", data); */
  }

  /* isItemLoaded(index) {
   *   !!this.state.items[index];
   * } */

  isItemLoaded = ({ index }) => !!this.state.items[index];

  loadMoreItems = (visibleStartIndex, visibleStopIndex) => {
    console.log("loadMoreItems: ", visibleStartIndex, visibleStopIndex);

    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true
    });

    console.log("loadNextPage loading...");

    return fetch(
      `/fashion/load_more?start_index=${visibleStartIndex}&stop_index=${visibleStopIndex}`
    ).then(response => {
      let data = response.json();
      console.log("data: ", data);
      /* this.setState(function(prevState, props) {
       *   prevState.items.push(response);
       *   return {
       *     items: prevState.items,
       *     isLoading: false
       *   };
       * }); */

      let items = this.state.items;
      items.push(response);

      this.setState({
        items: items,
        isLoading: false,
        count: items.length
      });

      // Store response data in list...
      /* for (let index = startIndex; index <= stopIndex; index++) {
       *   itemStatusMap[index] = LOADED;
       * } */

      console.log("loadNextPage loaded.");
    });
  };

  async loadMoreItems2(visibleStartIndex, visibleStopIndex) {
    console.log("loadMoreItems: ", visibleStartIndex, visibleStopIndex);

    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true
    });

    console.log("loadMoreItems loading...");

    let response = await fetch(
      `/fashion/load_more?start_index=${visibleStartIndex}&stop_index=${visibleStopIndex}`
    );

    let data = await response.json();
    console.log("data: ", data);

    let items = this.state.items;
    items.push(data);

    this.setState({
      items: items,
      isLoading: false,
      count: items.length + 1
    });

    console.log("loadMoreItems loaded.");

    return data;
  }

  renderItem = ({ index, style }) => {
    console.log("renderItem: ", index);
    let content;
    if (!this.isItemLoaded({ index })) {
      content = "Loading...";
    } else {
      const item = this.state.items[index];
      console.log("item: ", item);

      content = "loaded";
      content = item.html;
    }

    return <div style={style} dangerouslySetInnerHTML={{ __html: content }} />;
  };

  render() {
    /* if (this.state.isLoading) {
     *   return null;
     * } */

    console.log("FashionList render");

    /* let itemLoaded = isItemLoaded;
     * let loadMore = loadMoreItems; */
    /* let count = itemCount; */

    let rowHeight = 300;

    let isLoaded = isRowLoaded;
    let loadMore = loadMoreRows;
    let count = rowCount;

    let itemCount = this.state.count + 1;

    return (
      <div className="fashion-vertical">
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader
              isItemLoaded={this.isItemLoaded}
              itemCount={itemCount}
              loadMoreItems={this.loadMoreItems2}
            >
              {({ onItemsRendered, ref }) => (
                <List
                  className="List"
                  height={height}
                  itemCount={itemCount}
                  itemSize={rowHeight}
                  width={width}
                  onItemsRendered={onItemsRendered}
                  ref={ref}
                >
                  {this.renderItem}
                </List>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      </div>
    );
  }
}

export default FashionList;
